import styled from 'styled-components';
import { Heading, HeadingProps } from '@chakra-ui/react';

export const ModalTitle = styled(Heading).attrs({
  fontSize: 'lg',
  fontWeight: 'semibold',
  color: 'blue.800'
} as HeadingProps)`` as typeof Heading;
